import type { FC } from 'react';

import MuxPlayer from "@mux/mux-player-react";
import { Spinner, Text } from '@telegram-apps/telegram-ui';

interface VideoPlayerProps {
  playbackId: string | null;
  tokens: {
    playbackToken: string;
    thumbnailToken: string;
  } | null;
  onTimeUpdate: (event: Event) => void;
  playerRef: React.RefObject<unknown>;
  isLoading: boolean;
  shouldAutoplay?: boolean;
  aspectRatio?: string;
  metadata?: Record<string, string>;
}

const placeholderStyles = (aspectRatio: string): React.CSSProperties => ({
  width: '100%',
  aspectRatio: aspectRatio === 'auto' ? '16/9' : aspectRatio,
  backgroundColor: '#000',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  color: '#fff',
  fontSize: '18px'
});

export const VideoPlayer: FC<VideoPlayerProps> = ({
  playbackId,
  tokens,
  onTimeUpdate,
  playerRef,
  isLoading,
  shouldAutoplay = false,
  aspectRatio = 'auto',
  metadata = {}
}) => {
  // Get Telegram theme colors from CSS variables
  const accentColor = getComputedStyle(document.documentElement).getPropertyValue('--tg-theme-button-color').trim() || '#2481cc';
  const primaryColor = getComputedStyle(document.documentElement).getPropertyValue('--tg-theme-button-text-color').trim() || '#ffffff';

  if (isLoading) {
    return (
      <div style={placeholderStyles(aspectRatio)}>
        <Spinner size="l" />
      </div>
    );
  }

  if (!playbackId || !tokens) {
    return (
      <div style={placeholderStyles(aspectRatio)}>
        <Text>{'Видео не доступно'}</Text>
      </div>
    );
  }

  return (
    <MuxPlayer
      ref={playerRef as React.RefObject<never>}
      streamType="on-demand"
      playbackId={playbackId ?? undefined}
      tokens={{
        playback: tokens?.playbackToken ?? undefined,
        thumbnail: tokens?.thumbnailToken ?? undefined,
      }}
      metadata={metadata}
      accentColor={accentColor}
      primaryColor={primaryColor}
      onTimeUpdate={onTimeUpdate}
      autoPlay={shouldAutoplay}
      style={{
        '--time-display': 'block',
        aspectRatio: aspectRatio,
      } as React.CSSProperties}
    />
  );
};